//Dependencies
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { capitalize } from "lodash";
import { Breadcrumb } from "antd";
import { paths } from "../configApp";

const breadcrumbOptions = paths.map(({ label, path, noLinked }) => ({
  name: label,
  path,
  noLink: noLinked,
}));

const BreadcrumbComponent = ({ location }) => {
  const pathSnippets = location.pathname.split("/").filter((i) => i);
  const extraBreadcrumbItems = pathSnippets.map((item, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
    const breadcrumbItem = breadcrumbOptions.find((bc) => bc.path === url) || {
      noLink: true,
      path: url,
      name: item.replace("_", " "),
    };

    return (
      <Breadcrumb.Item key={url}>
        {breadcrumbItem.noLink ? (
          <span>{capitalize(breadcrumbItem.name)}</span>
        ) : (
          <Link to={breadcrumbItem.path}>
            {capitalize(breadcrumbItem.name)}
          </Link>
        )}
      </Breadcrumb.Item>
    );
  });

  const breadcrumbItems = [].concat(extraBreadcrumbItems);
  return <Breadcrumb>{breadcrumbItems}</Breadcrumb>;
};

export default withRouter(BreadcrumbComponent);
